import React, {Component} from 'react'
import {addRORO, addContainer} from '../../api/ShopsApi'
import {StyleSheet, Modal, Image, TextInput, TouchableOpacity, View, ScrollView, Picker} from 'react-native'
import {Button, Text} from 'react-native-elements'
import {widthPercentageToDP as wp, heightPercentageToDP as hp} from 'react-native-responsive-screen'
import {percWidth, percHeight} from '../../api/StyleFuncs'
import logo from '../../../assets/midasRed.png'
import {orderFormStyles} from './ContainerForm'
 



export default class OrderForm extends Component{
    constructor(props){
        super(props)
        this.basket = []
        this.state = {
            shipment: {},
            urlPDF: "",
            message: {
              subject: 'New Shipping Request:',
              text: 'Hello, \n You have received a new shipping request. Details outlined below',
              html: "",
            },

            manufacturer1: "",
            model1: "",
            year1: "",
            titleNo1: "",
            value1: "",
            vehicleID1: "",

            manufacturer2: "",
            model2: "",
            year2: "",
            titleNo2: "",
            value2: "",
            vehicleID2: "",

            manufacturer3: "",
            model3: "",
            year3: "",
            titleNo3: "",
            value3: "",
            vehicleID3: "",

            manufacturer4: "",
            model4: "",
            year4: "",
            titleNo4: "",
            value4: "",
            vehicleID4: "",

            manufacturer5: "",
            model5: "",
            year5: "",
            titleNo5: "",
            value5: "",
            vehicleID5: "",

            manufacturer6: "",
            model6: "",
            year6: "",
            titleNo6: "",
            value6: "",
            vehicleID6: "",

            message: "",
            to: "oyejr@hotmail.com",
        }
    }

    onOrderUploaded = () => {
    console.log('order uploaded')
    
   
  }


  componentDidMount = async () =>{
    
    this.checkValidity()
    const { route } = this.props;
    const { shipment } = route.params;
    this.setState({shipment : shipment }, () =>{
      console.log(this.state.shipment.type)
      if (this.state.shipment.type == "container"){
        let url = 'https://firebasestorage.googleapis.com/v0/b/midasshipping-c9c2e.appspot.com/o/CONTAINER%20SHIPMENT%20APPLICATION%20FORM-US_distributed.pdf?alt=media&token=205c5918-b274-482b-bc2f-845f6a38f5b1'
        this.setState({urlPDF : url})
      }
      if (this.state.shipment.type == "RORO"){
        let url = 'https://firebasestorage.googleapis.com/v0/b/midasshipping-c9c2e.appspot.com/o/RORO%20APPLICATION%20FORM-US_distributed%20(AutoRecovered).pdf?alt=media&token=b184f996-7222-4acb-bb0c-4331ed788875'
        this.setState({urlPDF : url})
      }
    })
    
  }




   
    

    onProductUploaded = () =>{
      console.log('product stock updated')
      
    }


    asyncForEach = async (array, callback) => {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    } 

    setMsg = () =>{
      let html = `
      <div>
      <span><b>Type: </b> ${this.state.shipment.type}\n</span>
      <span><a href =${this.state.urlPDF}>Click here to open PDF form with the Terms of Contract</a>\n</span>

      <br />
      <h2>Sender Details</h2>
      <span><b>Name: </b> ${this.state.shipment.senderName}\n</span>
      <span><b>Address: </b> ${this.state.shipment.senderAddr}\n</span>
      <span><b>City: </b> ${this.state.shipment.senderCity}\n</span>
      <span><b>State: </b> ${this.state.shipment.senderState}\n</span>
      <span><b>Zip: </b> ${this.state.shipment.senderZip}\n</span>
      <span><b>Phone: </b> ${this.state.shipment.senderPhone}\n</span>
      <span><b>E-mail: </b> ${this.state.shipment.senderEmail}\n</span>
      <br />
      <h2>Recipient Details</h2>
      <span><b>Name: </b> ${this.state.shipment.receiverName}\n</span>
      <span><b>Address: </b> ${this.state.shipment.receiverAddr}\n</span>
      <span><b>City: </b> ${this.state.shipment.receiverCity}\n</span>
      <span><b>State: </b> ${this.state.shipment.receiverState}\n</span>
      <span><b>Zip: </b> ${this.state.shipment.receiverZip}\n</span>
      <span><b>Phone: </b> ${this.state.shipment.receiverPhone}\n</span>
      <span><b>E-mail: </b> ${this.state.shipment.receiverEmail}\n</span>
      <br />
      <h2>Shipment Details </h2>
      <span><b>Country: </b> ${this.state.shipment.country}\n</span>
      <span><b>Description: </b> ${this.state.shipment.description}\n</span>
      <span><b>No. of Pieces: </b> ${this.state.shipment.nPieces}\n</span>
      <span><b>Value: </b> ${this.state.shipment.value}\n</span>
      <span><b>Hazardous: </b> ${this.state.shipment.hazardous}\n</span>
      <span><b>Insurance: </b> ${this.state.shipment.insure}\n</span>
      <span><b>Passport: </b> ${this.state.shipment.passportNo}\n</span>
      <span><b>IRS: </b> ${this.state.shipment.IRSNo}\n</span>
      <span><b>grimaldi: </b> ${this.state.shipment.grimaldi}\n</span>
      <span><b>sallum: </b> ${this.state.shipment.sallum}\n</span>
      <span><b>Delivery Port: </b> ${this.state.shipment.deliveryPort}\n</span>
      <span><b>Clearing Cost: </b> ${this.state.shipment.clearCost}\n</span>
      <br />
      <h2>Vehicle 1</h2>
      <span><b>Manufacturer: </b> ${this.state.manufacturer1}\n</span>
      <span><b>Model: </b> ${this.state.model1}\n</span>
      <span><b>Year: </b> ${this.state.year1}\n</span>
      <span><b>Title No.: </b> ${this.state.shipment.titleNo1}\n</span>
      <span><b>Value: </b> ${this.state.value1}\n</span>
      <span><b>Vehicle ID: </b> ${this.state.vehicleID1}\n</span>
      <h2>Vehicle 2</h2>
      <span><b>Manufacturer: </b> ${this.state.manufacturer2}\n</span>
      <span><b>Model: </b> ${this.state.model2}\n</span>
      <span><b>Year: </b> ${this.state.year2}\n</span>
      <span><b>Title No.: </b> ${this.state.shipment.titleNo2}\n</span>
      <span><b>Value: </b> ${this.state.value2}\n</span>
      <span><b>Vehicle ID: </b> ${this.state.vehicleID2}\n</span>
      <br />
      <h2>Vehicle 3</h2>
      <span><b>Manufacturer: </b> ${this.state.manufacturer3}\n</span>
      <span><b>Model: </b> ${this.state.model3}\n</span>
      <span><b>Year: </b> ${this.state.year3}\n</span>
      <span><b>Title No.: </b> ${this.state.shipment.titleNo3}\n</span>
      <span><b>Value: </b> ${this.state.value3}\n</span>
      <span><b>Vehicle ID: </b> ${this.state.vehicleID3}\n</span>
      <br />
      <h2>Vehicle 4</h2>
      <span><b>Manufacturer: </b> ${this.state.manufacturer4}\n</span>
      <span><b>Model: </b> ${this.state.model4}\n</span>
      <span><b>Year: </b> ${this.state.year4}\n</span>
      <span><b>Title No.: </b> ${this.state.shipment.titleNo4}\n</span>
      <span><b>Value: </b> ${this.state.value4}\n</span>
      <span><b>Vehicle ID: </b> ${this.state.vehicleID4}\n</span>
      <br />
      <h2>Vehicle 5</h2>
      <span><b>Manufacturer: </b> ${this.state.manufacturer5}\n</span>
      <span><b>Model: </b> ${this.state.model5}\n</span>
      <span><b>Year: </b> ${this.state.year5}\n</span>
      <span><b>Title No.: </b> ${this.state.shipment.titleNo5}\n</span>
      <span><b>Value: </b> ${this.state.value5}\n</span>
      <span><b>Vehicle ID: </b> ${this.state.vehicleID5}\n</span>
      <br />
      <h2>Vehicle 6</h2>
      <span><b>Manufacturer: </b> ${this.state.manufacturer6}\n</span>
      <span><b>Model: </b> ${this.state.model6}\n</span>
      <span><b>Year: </b> ${this.state.year6}\n</span>
      <span><b>Title No.: </b> ${this.state.shipment.titleNo6}\n</span>
      <span><b>Value: </b> ${this.state.value6}\n</span>
      <span><b>Vehicle ID: </b> ${this.state.vehicleID6}\n</span>
      


    </div>
    `
            
      let message = {
        subject: 'New Shipping Request:' + this.state.shipment.type,
        text: 'Hello, \n You have received a new shipping request. Details outlined below',
        html: html,
      }
      //this.setState({messgae: message})
      return message
    }


    onClickSubmit = async () => {
      let msg = this.setMsg()
      var obj = {
        to: 'oyejr@hotmail.com',
        message: msg
      }
      console.log(obj)
      console.log('1\n', msg)
      this.setState({message: msg}, async ()=>{
        
        console.log('2\n', JSON.parse(JSON.stringify(this.state.message)))
        //console.log('2\n', JSON.stringify(this.state.message))
        //console.log('2\n', JSON.parse(this.state.message))
        
        
        

        try{
          console.log('before')
          //await addContainer(obj, this.onOrderUploaded)
          await addContainer(JSON.parse(JSON.stringify(this.state)), this.onOrderUploaded)
          alert("Your request is being submitted \n please wait...")
          console.log('after')

          alert("Your request has been submitted.\nOur representative will be in contact shortly")
        } catch (error) {
          console.warn(error) 
          alert('Error: please check your internet connection and try again')
        }

        const {navigation} = this.props
        navigation.navigate(
          'Landing Form',
        )

    })
      
    }

 
    


    checkValidity = async () => {
      this.state.disableSubmit = false
      this.setState({forceRefresh: Math.floor(Math.random() * 100000000)})
      console.warn(this.state.disableSubmit)

    }
    


    render(){
        return(
            <ScrollView style = {orderFormStyles.regForm}>
                <View style = {{marginBottom: 100}}>
                <Image source = {logo} style = {orderFormStyles.modalPic} />
                <Text style = {orderFormStyles.header} >VEHICLE 1</Text>

                <Text style = {orderFormStyles.subHeader} >Manufacturer</Text>
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. Toyota"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.manufacturer1}
                  onChangeText={(text) =>{
                    this.setState({ manufacturer1: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>
             

                <Text style = {orderFormStyles.subHeader} >Model</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g Corolla X50 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.model1}
                  onChangeText={(text) =>{
                     this.setState({ model1: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Year</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 2020"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.year1}
                  onChangeText={(text) =>{
                     this.setState({ year1: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Title No. {"&"} State</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.titleNo1}
                  onChangeText={(text) =>{
                     this.setState({ titleNo1: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >USD Value ($)</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 20,000 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.value1}
                  onChangeText={(text) =>{
                     this.setState({ value1: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} > Vehicle Identification No. </Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.vehicleID1}
                  onChangeText={(text) =>{
                    this.setState({ vehicleID1: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>

                

                </View>

                <View style = {{marginBottom: 150}}>
                <Text style = {orderFormStyles.header} >VEHICLE 2</Text>

                <Text style = {orderFormStyles.subHeader} >Manufacturer</Text>
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. Toyota"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.manufacturer2}
                  onChangeText={(text) =>{
                    this.setState({ manufacturer2: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>
             

                <Text style = {orderFormStyles.subHeader} >Model</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g Corolla X50 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.model2}
                  onChangeText={(text) =>{
                     this.setState({ model2: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Year</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 2020"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.year2}
                  onChangeText={(text) =>{
                     this.setState({ year2: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Title No. {"&"} State</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.titleNo2}
                  onChangeText={(text) =>{
                     this.setState({ titleNo2: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >USD Value ($)</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 20,000 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.value2}
                  onChangeText={(text) =>{
                     this.setState({ value2: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} > Vehicle Identification No. </Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.vehicleID2}
                  onChangeText={(text) =>{
                    this.setState({ vehicleID2: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>

                

                </View>


              <View style = {{marginBottom: 150}}>
                <Text style = {orderFormStyles.header} >VEHICLE 3</Text>

                <Text style = {orderFormStyles.subHeader} >Manufacturer</Text>
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. Toyota"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.manufacturer3}
                  onChangeText={(text) =>{
                    this.setState({ manufacturer3: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>
             

                <Text style = {orderFormStyles.subHeader} >Model</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g Corolla X50 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.model3}
                  onChangeText={(text) =>{
                     this.setState({ model3: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Year</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 2020"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.year3}
                  onChangeText={(text) =>{
                     this.setState({ year3: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Title No. {"&"} State</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.titleNo3}
                  onChangeText={(text) =>{
                     this.setState({ titleNo3: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >USD Value ($)</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 20,000 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.value}
                  onChangeText={(text) =>{
                     this.setState({ value: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} > Vehicle Identification No. </Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.vehicleID3}
                  onChangeText={(text) =>{
                    this.setState({ vehicleID3: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>

                

                </View>



                <View style = {{marginBottom: 150}}>
                <Text style = {orderFormStyles.header} >VEHICLE 4</Text>

                <Text style = {orderFormStyles.subHeader} >Manufacturer</Text>
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. Toyota"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.manufacturer4}
                  onChangeText={(text) =>{
                    this.setState({ manufacturer4: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>
             

                <Text style = {orderFormStyles.subHeader} >Model</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g Corolla X50 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.model4}
                  onChangeText={(text) =>{
                     this.setState({ model4: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Year</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 2020"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.year4}
                  onChangeText={(text) =>{
                     this.setState({ year4: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Title No. {"&"} State</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.titleNo4}
                  onChangeText={(text) =>{
                     this.setState({ titleNo4: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >USD Value ($)</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 20,000 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.value4}
                  onChangeText={(text) =>{
                     this.setState({ value4: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} > Vehicle Identification No. </Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.vehicleID4}
                  onChangeText={(text) =>{
                    this.setState({ vehicleID4: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>

               

                </View>



              <View style = {{marginBottom: 150}}>
                <Text style = {orderFormStyles.header} >VEHICLE 5</Text>

                <Text style = {orderFormStyles.subHeader} >Manufacturer</Text>
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. Toyota"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.manufacturer5}
                  onChangeText={(text) =>{
                    this.setState({ manufacturer5: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>
             

                <Text style = {orderFormStyles.subHeader} >Model</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g Corolla X50 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.model5}
                  onChangeText={(text) =>{
                     this.setState({ model5: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Year</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 2020"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.year5}
                  onChangeText={(text) =>{
                     this.setState({ year5: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Title No. {"&"} State</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.titleNo5}
                  onChangeText={(text) =>{
                     this.setState({ titleNo5: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >USD Value ($)</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 20,000 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.value5}
                  onChangeText={(text) =>{
                     this.setState({ value5: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} > Vehicle Identification No. </Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.vehicleID5}
                  onChangeText={(text) =>{
                    this.setState({ vehicleID5: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>

                

                </View>



              <View style = {{marginBottom: 150}}>
                <Text style = {orderFormStyles.header} >VEHICLE 6</Text>

                <Text style = {orderFormStyles.subHeader} >Manufacturer</Text>
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. Toyota"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.manufacturer6}
                  onChangeText={(text) =>{
                    this.setState({ manufacturer6: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>
             

                <Text style = {orderFormStyles.subHeader} >Model</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g Corolla X50 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.model6}
                  onChangeText={(text) =>{
                     this.setState({ model6: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Year</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 2020"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.year6}
                  onChangeText={(text) =>{
                     this.setState({ year6: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >Title No. {"&"} State</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.titleNo6}
                  onChangeText={(text) =>{
                     this.setState({ titleNo6: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} >USD Value ($)</Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. 20,000 "}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.value6}
                  onChangeText={(text) =>{
                     this.setState({ value6: text})
                     setTimeout(()=>this.checkValidity(),500)
                     }}/>

                <Text style = {orderFormStyles.subHeader} > Vehicle Identification No. </Text>  
                <TextInput style = {orderFormStyles.textInput}
                  placeholderTextColor = {'grey'}
                  placeholder = {""}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.vehicleID6}
                  onChangeText={(text) =>{
                    this.setState({ vehicleID6: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>

                <TouchableOpacity 
                  disabled = {this.state.disableSubmit}
                  style = {orderFormStyles.modalButton}
                  onPress = {() => this.onClickSubmit()}>
                  <Text style = {orderFormStyles.buttonText}>SUBMIT</Text>
                </TouchableOpacity>

                </View>





      

                

               

                
            </ScrollView>
      
        )
    }
  }



  